var m = require('mithril');
var loaders = require('../../layout/components/loaders');
var Model = require('../../libs/Model');
var fieldnetTree = require('../../network/components/fieldnetTree');

var overrideMode = Object.create(Model);

overrideMode.name = 'Override Mode Point';
overrideMode['@class'] = 'OverrideMode';
overrideMode.url = 'overridemode';

overrideMode.fields = {
  out: {
    validators : {
      presence: true
    }
  },
  in: {
    validators: {
      presence: true
    }
  }
};

overrideMode.view = function (ctrl) {
  return m(fieldnetTree, {selectedPoint: overrideMode.form.in});
};

module.exports = overrideMode;
